require('js-cookie');
require('./init');
require('./slickSlider.js');

// Sass
require('../sass/index.sass');